import React from 'react';
import CategoryIcon from '@mui/icons-material/Category';
import SimpleLookupManagement, { LookupField } from './SimpleLookupManagement';

const fields: LookupField[] = [{ key: 'name', label: 'Name', required: true, helperText: 'e.g. "Herbicide"' }];

const ProductCategoryManagement: React.FC = () => (
  <SimpleLookupManagement
    title="Product Category Management"
    icon={<CategoryIcon />}
    apiPath="/api/product-categories"
    fields={fields}
    entityLabel="Category"
  />
);

export default ProductCategoryManagement;
